import * as preferencesApi from '../../api/preferences-api';
import { IOrderNotificationPreference } from '../../models/order-notification-preference';
import { IResult, IErrorResult } from '../../models/result-models';
import { getErrorMessage } from '../../utils/error-handling';
import { apiCallError, beginApiCall } from '../api/api-status-action';

export const LOAD_ORDER_PREFERENCES_SUCCESS = 'LOAD_ORDER_PREFERENCES_SUCCESS';
export const SAVE_ORDER_PREFERENCES_SUCCESS = 'SAVE_ORDER_PREFERENCES_SUCCESS';
export const ORDER_PREFERENCES_FATAL = 'ORDER_PREFERENCES_FATAL';

// Actions
const loadOrderPreferencesSuccess = (
    payload: IResult<IOrderNotificationPreference[]>
) => ({
    type: LOAD_ORDER_PREFERENCES_SUCCESS,
    payload,
});

const saveOrderPreferencesSuccess = (
    payload: IResult<IOrderNotificationPreference[]>
) => ({
    type: SAVE_ORDER_PREFERENCES_SUCCESS,
    payload,
});

const orderPreferencesError = (payload: IErrorResult) => ({
    type: ORDER_PREFERENCES_FATAL,
    payload,
});

// Thunks
export const loadOrderPreferences = (id?: string) => {
    return async (dispatch: any) => {
        dispatch(beginApiCall());
        try {
            const result = await preferencesApi.getOrderPreferences(id);
            dispatch(loadOrderPreferencesSuccess(result));
        } catch (error) {
            dispatch(apiCallError(error));
        }
    };
};

export const saveOrderPreferences = (
    preferences: IOrderNotificationPreference[],
    id?: string
) => {
    return async (dispatch: any) => {
        dispatch(beginApiCall());
        try {
            const result = await preferencesApi.saveOrderPreferences(
                preferences,
                id
            );
            dispatch(
                saveOrderPreferencesSuccess({ ok: true, data: preferences })
            );
            return result.ok;
        } catch (error) {
            dispatch(
                orderPreferencesError({ errorMessage: getErrorMessage(error) })
            );
            dispatch(apiCallError(error));
            throw error;
        }
    };
};
